"use strict";

exports.__esModule = true;
exports.EventListener = EventListener;

var _useEventListener = require("./useEventListener");

function EventListener(props) {
  (0, _useEventListener.useEventListener)(props);
  return null;
}

EventListener.defaultProps = {
  capture: false
};
//# sourceMappingURL=EventListener.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@fluentui/react-component-event-listener/dist/commonjs/EventListener.js
// module id = 708
// module chunks = 0